import { chargingPointStatusUtils } from '@/utils/chargingPointStatus'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import ChargingSessionBody from '../components/ChargingSessionBody'

const MaintenanceChargingPointScreen: React.FC<ChargingPointScreenProps> = (props) => {
  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <>
              Este carregador está em{' '}
              <b style={{ color: chargingPointStatusUtils.getColorValue('MAINTENANCE') }}>manutenção</b>.
              <br />
              Por favor, utilize um carregador disponível.
            </>
          }
        />
      }
    />
  )
}

export default MaintenanceChargingPointScreen
